import { render } from "./dash-line-speed.svg?vue&type=template&id=60a83232"
const script = {}
script.render = render

export default script